module.exports = __webpack_public_path__ + "static/media/Home-page-img5.425eb38c.png";